
import {defineComponent, PropType} from 'vue';
import {User} from './types';
import Icon from '@ohrm/oxd/core/components/Icon/Icon.vue';
import DropdownMenu from '@ohrm/oxd/core/components/DropdownMenu/DropdownMenu.vue';

export default defineComponent({
  name: 'oxd-user-dropdown',

  props: {
    user: {
      type: Object as PropType<User>,
    },
  },

  components: {
    'oxd-icon': Icon,
    'oxd-dropdown-menu': DropdownMenu,
  },

  computed: {
    profilePicUrl() {
      return this.user.profImgSrc != ''
        ? this.user.profImgSrc
        : require('../../../assets/images/user-default-400.png');
    },
  },
});
